import React, { useEffect } from "react";
import { useDrag } from "react-dnd";

import { DND_ITEM_TYPES } from "~/src/consts";
import { formatHours } from "~/src/containers/scheduler/utils";

import {
  StyledOpenShiftContainer,
  Div,
  GridCardWrapper
} from "~/src/containers/scheduler/OpenShifts/OpenShiftDailyCard/open-shift-daily-card.styles";

import { StyledMaskContainer } from "../../GridCard/grid-card.styles";

import { getCardProps } from "../../card-styles";

export const OpenShiftDailyCard = ({
  shift,
  assignMemberLoading,
  lastDraggedShiftId,
  setLastDraggedShiftId,
  focusShift,
  onFocusShift
}) => {
  const [{ draggedShift, isDragging }, drag] = useDrag(
    () => ({
      type: DND_ITEM_TYPES.OPEN_SHIFT,
      item: () => shift,
      canDrag: () => true,
      collect: monitor => ({
        isDragging: monitor.isDragging(),
        draggedShift: monitor.getItem()
      })
    }),
    [shift]
  );

  useEffect(() => {
    if (isDragging && draggedShift.id !== lastDraggedShiftId) {
      setLastDraggedShiftId(draggedShift?.id);
    }
  }, [isDragging]);

  const isShiftLoading =
    assignMemberLoading && lastDraggedShiftId === shift?.id;

  const isFaded = focusShift !== null && focusShift?.id !== shift.id;

  return (
    <StyledOpenShiftContainer className={isFaded ? "faded" : ""}>
      <GridCardWrapper
        {...getCardProps(
          shift,
          shift.hasCancelledBookings,
          undefined,
          (shift.reservedBookings?.totalResults || 0) > 0
        )}
        ref={drag}
        lineHeight="12px"
        onClick={() => onFocusShift(shift /*, e.detail*/)}
        isLoading={isShiftLoading}
      >
        <StyledMaskContainer>
          <Div>
            {`${(shift?.bookings.totalResults || 0) +
              (shift.reservedBookings?.totalResults || 0)}/${
              shift?.numberRequested
            } ${shift.roleRate.roleName}`}{" "}
          </Div>
          <Div fontWeight="500">{formatHours(shift)}</Div>
          <Div>{`${shift?.venue?.name} (${shift?.sourceAccount.accountName})`}</Div>
        </StyledMaskContainer>
      </GridCardWrapper>
    </StyledOpenShiftContainer>
  );
};
